// extracted by mini-css-extract-plugin
export default {"input":"D7-z","button":"E7-z","selected":"F7-z","unavailable":"G7-z","oos":"H7-z","image":"I7-z","paperCutDisabledOverlay":"J7-z"};